/**
 * Converts basic markdown syntax to HTML.
 * @param {string} markdown - The markdown content to convert.
 * @returns {string} The converted HTML content.
 */
export function markdownToHtml(markdown) {
  if (typeof markdown !== "string") return "";

  return markdown
    // Normalize newlines
    .replace(/\r/g, "")

    // Convert escaped newlines
    .replace(/\\n/g, "\n")

    // Escape HTML
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")

    // Headers
    .replace(/^\s*######\s*(.*?)\s*$/gm, "<h6>$1</h6>")
    .replace(/^\s*#####\s*(.*?)\s*$/gm, "<h5>$1</h5>")
    .replace(/^\s*####\s*(.*?)\s*$/gm, "<h4>$1</h4>")
    .replace(/^\s*###\s*(.*?)\s*$/gm, "<h3>$1</h3>")
    .replace(/^\s*##\s*(.*?)\s*$/gm, "<h2>$1</h2>")
    .replace(/^\s*#\s*(.*?)\s*$/gm, "<h1>$1</h1>")

    // Bold
    .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")

    // Italic
    .replace(/\*(.*?)\*/g, "<em>$1</em>")

    // Inline code
    .replace(/`(.*?)`/g, "<code>$1</code>")

    // Links
    .replace(
      /\[(.*?)\]\((.*?)\)/g,
      '<a href="$2" target="_blank">$1</a>'
    )

    // Line breaks
    .replace(/\n/g, "<br>");
}
